/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:599px){.collapse-click.collapsed[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;z-index:1}}.added-icon[_ngcontent-%COMP%]{height:24px;width:24px}.no-promo-text[_ngcontent-%COMP%]{padding-right:unset}"];
export { styles as styles };
